var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3713 26.0837L20.3712 26.0831C20.3546 26.0108 20.3356 25.9327 20.3152 25.8488C20.1656 25.2326 19.9401 24.3044 20.0193 23.0841C20.1098 21.691 20.5851 19.9764 21.8442 17.7957C23.4153 15.0743 22.7779 11.7879 20.4874 9.74461L19.8802 9.203L20.287 8.49839L20.7755 7.65239C20.9138 7.41284 20.8313 7.1073 20.5933 6.96985C20.3552 6.83239 20.0494 6.91378 19.9111 7.15333L19.4226 7.99933L19.0158 8.70394L18.2432 8.44895C15.3284 7.48695 12.1635 8.57809 10.5924 11.2995C9.33333 13.4802 8.08606 14.7491 6.92491 15.524C5.90776 16.2028 4.99111 16.4716 4.38261 16.6501C4.29976 16.6744 4.22262 16.697 4.15171 16.7188C4.00839 16.7628 3.92217 16.8437 3.86939 16.9365C3.86937 16.9365 3.86936 16.9365 3.86935 16.9365M20.3713 26.0837L3.00003 16.4423L3.86935 16.9365M20.3713 26.0837C20.4047 26.2286 20.3781 26.344 20.3238 26.4365L20.3235 26.437C20.1827 26.6775 19.8831 26.7671 19.6334 26.6229L4.05312 17.6276C3.80385 17.4837 3.73117 17.1797 3.86935 16.9365M20.3713 26.0837L3.86935 16.9365M11.5925 26.022C10.9942 26.3669 10.2336 26.3921 9.59327 26.0224C8.95298 25.6527 8.59446 24.9815 8.59403 24.2908L11.5925 26.022Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.376c88be8fc8aaef194e56967ca0bf23.svg";
export { ForwardRef as ReactComponent };